var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxisbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5316_15784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3787 3.29297C24.6606 7.21291 26.9621 11.1213 29.2193 15.0561C25.571 21.4916 21.9754 27.9585 18.2036 34.3232C16.7565 36.7664 15.3488 39.2326 13.9182 41.684C9.27878 41.712 4.63939 41.7103 0 41.7038C0.141585 41.386 0.281524 41.0666 0.452744 40.7637C7.75756 28.2713 15.0904 15.7953 22.3787 3.29297Z",
    fill: "#AE285D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.38 27.191C27.0359 27.1893 31.6917 27.1564 36.3476 27.2338C39.12 32.0674 41.9813 36.8484 44.7291 41.6952C40.0732 41.7183 35.419 41.7002 30.7632 41.6969C27.9924 36.8468 25.0981 32.0707 22.38 27.191Z",
    fill: "#AE285D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5316_15784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxisbank);
export default __webpack_public_path__ + "static/media/axisbank.19a00afffa0946c3a82821e6ec48ef2e.svg";
export { ForwardRef as ReactComponent };